import React from "react";
import './App.css';
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
     <Weather defaultCity="Rio de Janeiro" />
     <footer>
       Coded by <a 
       href="https://nl.linkedin.com/in/karoline-camara"
       target="_blank"
       rel="noreferrer">
         Karol Camara</a> and is <a 
       href="https://github.com/karolcamara/new-weather-react"
       target="_blank"
       rel="noreferrer">
        open-sourced on GitHub.</a>
         </footer>
         </div>
    </div>
  );
}

